import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const api = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
});

export const loginApi = async (payload) => {
  const res = await api.post("/user/login", payload);
  return res.data;
};

export const googleLoginApi = async (access_token) => {
  const res = await api.post("/user/google-login", { access_token });
  return res.data;
};


export default api;
